import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import Box from '@/modules/components/Box'
import Button from '@/modules/components/Button'
import Flex from '@/modules/components/Flex'
import Icon from '@/modules/components/Icon'
import Typography from '@/modules/components/Typography'
import { mobileFirstDevice } from '@/utils/media-queries'

import Logo from './cdc-tax-light.png'
import { useIsMobile } from './useIsMobile'

const BannerOuter = styled('div')`
  width: 100%;
  z-index: 3;
  position: relative;
  @media ${mobileFirstDevice.mobile} {
    margin-top: 0;
    top: 53px;
  }
  @media ${mobileFirstDevice.tablet} {
    top: 0;
  }
  @media ${mobileFirstDevice.laptop} {
    top: 0;
  }
`

const TaxBanner = ({ setBannerClose, curKey }) => {
  const isMobile = useIsMobile()
  const [hasFilter, setHasFilter] = useState(false)

  useEffect(() => {
    const keyArr = curKey.split('/').slice(1)
    if (keyArr.length === 1 && keyArr[0] !== 'trending') {
      setHasFilter(true && isMobile)
    } else {
      setHasFilter(false && isMobile)
    }
  }, [curKey, isMobile])

  return (
    <BannerOuter style={{ top: !isMobile ? 0 : hasFilter ? '53px' : '0px' }}>
      <Flex
        backgroundColor={'#1330AB'}
        justifyContent={['center']}
        alignItems={'center'}
        height={['68px', '92px']}
        zIndex={3}
      >
        <Box
          mr={['20px', '20px', 0]}
          ml={['auto']}
          display="flex"
          alignItems={'center'}
          order={[1, 1, 0]}
        >
          <Box
            as="img"
            src={Logo}
            width={[null, 182, 204]}
            display={['none', 'block']}
          />
          <Typography
            variant="p"
            fontSize={[14, 18]}
            fontWeight={[500, 600]}
            lineHeight={['120%']}
            letterSpacing={['0.02em', '0px']}
            ml={[0, '36.5px', 8]}
            mr={['12px', '28.5px', '62px']}
            color={'white'}
            maxWidth={[165, 218, 'unset']}
          >
            Free tax prep. 30+ platforms supported.
          </Typography>

          <a
            href={`https://tax.crypto.com/?utm_source=website&utm_medium=banner&utm_campaign=tax2023&utm_term=contenthub`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button
              variant="plain"
              paddingX={['20px !important', '40px !important']}
              paddingY={['8px !important', '16px !important']}
              backgroundColor={'#F3F4F9 !important'}
              borderRadius={'6px'}
            >
              <Typography
                variant="p"
                color={'#003688'}
                fontSize={[14, 18]}
                fontWeight={600}
                lineHeight={'100%'}
                letterSpacing={'0.02em'}
              >
                Sign Up Now
              </Typography>
            </Button>
          </a>
        </Box>
        <Button
          variant="plain"
          onClick={() => setBannerClose(false)}
          ml={['18px', 3, 'auto']}
          mr={[0, 0, 3]}
          order={[0, 0, 1]}
        >
          <Icon.Close fontSize={['12px', '18px']} color="#C9CFDD" />
        </Button>
      </Flex>
    </BannerOuter>
  )
}

export default TaxBanner
